import React, { Component } from 'react';
import {connect} from 'react-redux'
import CategorysList from './CategorysList'
import { Link } from "react-router-dom";
import {addOptionQueryParam} from '../../redux/actions'

class CategoryAlbum extends Component{
  render(){
    let category =  this.props.category;
    console.log(category);
    return (
      <div>
        <Link to={`/choose?category=${category.name}&treeId=${category.defTree}&ordering=-score`}>
          <img src={`${category.img}`} alt="category image" className="optionImg img-thumbnail"
            onClick={() => {
              this.props.addOptionQueryParam("category", category.name);
              this.props.addOptionQueryParam("treeId", category.defTree);
            }}>
          </img>
        </Link>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
})

const actionsCreators = {
  addOptionQueryParam:addOptionQueryParam
}
export default connect(mapStateToProps, actionsCreators)(CategoryAlbum)
